import {
	AfterViewInit,
	Component,
	ElementRef,
	OnInit,
	QueryList,
	ViewChildren,
} from '@angular/core';
import { CommonModule } from '@angular/common';

// Service Imports
import { DecrypttextService } from 'src/app/services/decrypttext.service';

@Component({
	selector: 'app-footer',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, AfterViewInit {
	@ViewChildren('decryptedtext', { read: ElementRef })
	decryptedtextElement!: QueryList<ElementRef>;

	constructor(private decryptMessage: DecrypttextService) {}

	decryptedtext: string = '';
	encryptedtext: string = getComputedStyle(document.documentElement)
		.getPropertyValue('--addr-webm')
		.slice(1, -1);
	key: string = '123456$#@$^@1ERF-dingDONG';

	ngOnInit(): void {
		this.getMsg();
	}

	ngAfterViewInit(): void {
		this.decryptedtextElement.first.nativeElement.innerHTML =
			this.decryptedtext;
	}

	getMsg(): void {
		this.decryptedtext = this.decryptMessage.get(
			this.encryptedtext,
			this.key
		);
	}

	setMsg(): void {
		this.decryptedtext = this.decryptMessage.set(
			this.encryptedtext,
			this.key
		);
	}
}
